import React from "react";
import { useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";

/**
 * AdminRoute: admin-only wrapper.
 * Non-admins get the Landing page (simulates 404 — page does not exist to them).
 * While auth state is loading we show nothing to avoid flashing Landing then admin content.
 */
export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user || !user.is_admin) {
    return <Landing />;
  }
  return children;
}
